<template>
  <ul>
    <slot></slot>
  </ul>
</template>
<script>
import Emitter from '../../mixins/emitter'

export default {
  name: 'TDropdownMenu',
  mixins: [Emitter],
  props: {
    value: {
      type: Object
    }
  },
  mounted() {
    if (this.value !== undefined) {
      this.selectItem(this.value)
    }
    this.$on('dropdown-item-click', item => {
      this.$emit('input', item)
      // 将值传递给嵌套在外层的dropdown-menu组件
      this.dispatch('TDropdownMenu', 'dropdown-menu-selected', item)
    })
    // 接收嵌套在dropdown-item内的dropdown-menu组件传递过来的选中值
    this.$on('dropdown-menu-selected', item => {
      this.$emit('input', item)
    })
  },
  methods: {
    selectItem(value) {
      let $children = this.$children
      for (let i = $children.length - 1; i >= 0; i--) {
        $children[i].$emit('dropdown-menu-select-item', this.value.name)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// dropdown-menu.vue?81b7e3b2